import { Button, Slider } from "@mantine/core";
import React, { useRef } from "react";
import { BiVolumeFull, BiVolumeMute } from "react-icons/bi";

import { useStateContext } from "@/context/context-provider";

import styles from "./sound-slider.module.css";

type SoundSliderProps = {
    soundSetting?: "default" | "background";
};

const SoundSlider = ({ soundSetting = "default" }: SoundSliderProps) => {
    const { soundSettings, updateSoundSettings } = useStateContext();
    const testSound = useRef<HTMLAudioElement | null>(null);

    const isMuted = soundSetting === "default" ? soundSettings.muted : soundSettings.mutedBackground;
    const currentVolume = soundSetting === "default" ? soundSettings.volume : soundSettings.volumeBackground;

    const playTestSound = (volumeValue: number) => {
        if (testSound.current) {
            testSound.current.volume = volumeValue * 0.05;
            testSound.current.play().catch(() => {});
        }
    };

    return (
        <div className={styles.sound}>
            <Button
                radius="md"
                mt="auto"
                size="lg"
                className={styles.soundButton}
                onClick={() => {
                    updateSoundSettings((prev) =>
                        soundSetting === "default" ? { ...prev, muted: !prev.muted } : { ...prev, mutedBackground: !prev.mutedBackground }
                    );
                    playTestSound(currentVolume);
                }}>
                {isMuted ? <BiVolumeMute /> : <BiVolumeFull />}
            </Button>

            <Slider
                className={styles.soundSlider}
                disabled={isMuted}
                value={Math.round(currentVolume * 30)}
                marks={[
                    { value: 20, label: "20%" },
                    { value: 50, label: "50%" },
                    { value: 80, label: "80%" },
                ]}
                onChangeEnd={(value) => {
                    const volumeValue = value / 30;
                    updateSoundSettings((prev) =>
                        soundSetting === "default" ? { ...prev, volume: volumeValue } : { ...prev, volumeBackground: volumeValue }
                    );
                    playTestSound(volumeValue);
                }}
            />
            <audio ref={testSound} src="/general/sounds/pickup.mp3" preload="auto" muted={isMuted} />
        </div>
    );
};

export default SoundSlider;
